package dev.inmo.wishlist.features.ui.adminPanel.ui

import dev.inmo.wishlist.features.common.client.models.ViewConfig
import kotlinx.serialization.Serializable

/** Navigation config for the admin panel dashboard screen — entry point for admin flows. */
@Serializable
class AdminPanelViewConfig : ViewConfig
